import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext();

const defaults = {
  theme: "parchment", // parchment | dark | white
  fontSize: "m",       // s | m | l | xl | 2xl
  nikud: true,         // show vowels
  showVerseNums: true,
  focusMode: false,
  readingMode: "book", // book (3D page-flip, default) | study (flat scroll)
  autoContinue: true,  // קריאה רציפה — auto-load next chapter at end
};

export function ThemeProvider({ children }) {
  const [state, setState] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem("tanakh_prefs") || "{}");
      // Force nikud back ON — the toggle was removed from settings and the
      // Torah text must always display with vowels + cantillation marks.
      // This also corrects any user whose old localStorage had {nikud:false}.
      return { ...defaults, ...saved, nikud: true };
    } catch {
      return defaults;
    }
  });

  useEffect(() => {
    localStorage.setItem("tanakh_prefs", JSON.stringify(state));
    document.documentElement.setAttribute("data-theme", state.theme);
    document.documentElement.classList.toggle("dark", state.theme === "dark");
  }, [state]);

  const update = (patch) => setState((s) => ({ ...s, ...patch }));

  return (
    <ThemeContext.Provider value={{ ...state, update }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
